<template>
  <div>
    <!-- Waitlist button -->
    <v-tooltip :bottom="!isLeft" :left="isLeft">
      <template v-slot:activator="{ on }">
        <v-btn 
          v-on="on"
          :color="(meeting.places - meeting.validated_subscribers_count) > 0 ? 'primary' : 'red'"
          small
          :loading="loading"
          @click="handleButtonClick"
          :class="{'pulse-animation': (meeting.places - meeting.validated_subscribers_count) > 0}"
        >
          {{ (meeting.places - meeting.validated_subscribers_count) > 0 ? 'Sur liste d\'attente' : buttonText }}
        </v-btn>
      </template>
      <span>{{ (meeting.places - meeting.validated_subscribers_count) > 0 ? 'Une place est disponible !' : tooltipText }}</span>
    </v-tooltip>

    <!-- Dialog for waitlist options -->
    <v-dialog v-model="dialogOpen" max-width="700px">
      <v-card :color="isThemeAja ? '#1E3945' : ''" :style="{'border': '1em solid white'}">
        <v-card-title :class="{'headline py-3 px-3': true, 'white--text': isDarkTheme, 'black--text': !isDarkTheme}">
          Une place est disponible !
        </v-card-title>
        <v-card-text :class="{'py-3 px-3': true, 'white--text': isDarkTheme, 'black--text': !isDarkTheme}">
          Que souhaitez-vous faire ?<br>
          <span class="grey--text">
            A noter: Vous serez désinscrit des séances de la même séquence.
          </span>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="flex-wrap">
          <v-btn
            color="secondary"
            @click="handleCancel"
            class="mx-2 my-2"
            dense
            depressed
            :loading="actionLoading"
            :disabled="actionLoading"
          >
            Renoncer à la liste d'attente
          </v-btn>
          <v-spacer class="hidden-xs-only"></v-spacer>
          <v-btn
            :color="isThemeAja ? '#4E983C' : 'primary'"
            dark
            @click="handleTake"
            class="mx-2 my-2"
            dense
            depressed
            :loading="actionLoading"
            :disabled="actionLoading"
          >
            Prendre la place libérée !
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'WaitlistButton',
  props: {
    meeting: {
      type: Object,
      required: true
    },
    isLeft: {
      type: Boolean,
      default: false
    },
    buttonText: {
      type: String,
      default: 'Sortir de liste d\'attente'
    },
    tooltipText: {
      type: String,
      default: 'Cliquer pour vous désabonner'
    },
    loading: {
      type: Boolean,
      default: false
    },
    isThemeAja: {
      type: Boolean,
      default: false
    },
    isDarkTheme: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialogOpen: false,
      actionLoading: false
    }
  },
  methods: {
    handleButtonClick() {
      if (this.meeting.places - this.meeting.validated_subscribers_count > 0) {
        this.dialogOpen = true;
      } else {
        this.$emit('unsubscribe', this.meeting.id);
      }
    },
    async handleCancel() {
      this.actionLoading = true;
      try {
        this.$emit('unsubscribe', this.meeting.id);
        this.dialogOpen = false;
      } finally {
        this.actionLoading = false;
      }
    },
    async handleTake() {
      this.actionLoading = true;
      try {
        this.$emit('take-place', this.meeting);
        this.dialogOpen = false;
      } finally {
        this.actionLoading = false;
      }
    }
  }
}
</script>

<style scoped>
.pulse-animation {
  animation: pulse 1.5s infinite;
  box-shadow: 0 0 0 rgba(76, 175, 80, 0.4);
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(76, 175, 80, 0.4);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(76, 175, 80, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(76, 175, 80, 0);
  }
}
</style> 